// Тост по образцу Orbis: тёмная плашка с цветной иконкой смысла.
import { openTask } from '../router.tsx'
import { dismissToast, useToasts } from '../toast.ts'
import { Icon } from './Icon.tsx'
import { cx } from './ui.tsx'

export function Toasts() {
  const items = useToasts()
  return (
    <div
      className="pointer-events-none fixed right-4 bottom-4 z-[70] flex w-[min(400px,calc(100vw-32px))] flex-col gap-2"
      aria-live="polite"
      role="status"
    >
      {items.map((t) => (
        <div
          key={t.id}
          className="anim-fade-in pointer-events-auto flex items-start gap-2.5 rounded-card bg-fg px-3.5 py-2.5 text-[13px] font-[550] text-bg shadow-pop"
        >
          <Icon
            name={t.tone === 'error' ? 'alertCircle' : t.tone === 'success' ? 'check' : 'dot'}
            className={cx('mt-0.5 shrink-0', t.tone === 'error' ? 'text-danger' : t.tone === 'success' ? 'text-ok' : 'text-subtle')}
          />
          {t.taskId ? (
            <button
              type="button"
              className="min-w-0 flex-1 cursor-pointer text-left break-words"
              onClick={() => {
                openTask(t.taskId!)
                dismissToast(t.id)
              }}
            >
              {t.title ? <span className="block font-semibold">{t.title}</span> : null}
              <span className={cx('block', t.title && 'mt-0.5 font-normal opacity-90')}>{t.message}</span>
              <span className="mt-1 block text-[12px] font-semibold text-ok">Открыть задачу →</span>
            </button>
          ) : (
            <div className="min-w-0 flex-1 break-words">
              {t.title ? <span className="block font-semibold">{t.title}</span> : null}
              {t.message}
            </div>
          )}
          <button
            type="button"
            aria-label="Скрыть уведомление"
            className="-mr-1 rounded p-0.5 text-subtle hover:text-bg"
            onClick={() => dismissToast(t.id)}
          >
            <Icon name="x" size={14} />
          </button>
        </div>
      ))}
    </div>
  )
}
